import { render, staticRenderFns } from "./ClassesById.vue?vue&type=template&id=e07e1240&scoped=true&"
import script from "./ClassesById.vue?vue&type=script&lang=js&"
export * from "./ClassesById.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e07e1240",
  null
  
)

export default component.exports